import { useAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { CircularProgressModal } from '@!/components/Modal'
import { isBlank } from '@!/Util'
import { cardInfoAtom, payTypeAtom, monthlyCourseIdAtom, restoreOrderIdAtom } from '@!/atoms/paymentAtom'
import { useAppCookies } from '@!/Hooks'
import { usePaymentValidation, useMonthlyCourseRegister } from '@!/User/Payment/Hooks'
import { PayTypeSelector, RestoreHeader } from '@!/User/Payment/components/MonthlyCourse'

export const PaymentSelect = ({ restore }) => {
  usePaymentValidation()

  const navigate = useNavigate()
  const [cardInfo] = useAtom(cardInfoAtom)
  const [, setPayType] = useAtom(payTypeAtom)
  const { lastMonthlyCoursePayTypeCookie } = useAppCookies()

  const [monthlyCourseId] = useAtom(monthlyCourseIdAtom)
  const [restoreOrderId] = useAtom(restoreOrderIdAtom)
  const { executeRegister, isRegistering } = useMonthlyCourseRegister()

  // 登録
  const handleRegister = (payType) => {
    executeRegister(payType, monthlyCourseId, restoreOrderId, restore)
  }

  // 決済方法変更
  const handleChangePayType = (payType) => {
    setPayType(payType)

    if (payType === 'credit' && isBlank(cardInfo)) {
      navigate('/monthly_course/new_card')
      return
    }

    navigate('/monthly_course/confirm')
  }

  // カード変更
  const handleChangeCard = (e) => {
    e.preventDefault()
    setPayType('credit')
    navigate('/monthly_course/new_card')
  }

  const pageBack = (e) => {
    e.preventDefault()

    if (restore) {
      window.location.href = '/user/monthly_course_histories'
    } else {
      navigate(-1)
    }
  }

  return (
    <>
      {restore && <RestoreHeader />}
      <PayTypeSelector
        handleRegister={handleRegister}
        handleChangePayType={handleChangePayType}
        pageBack={pageBack}
        lastMonthlyCoursePayTypeCookie={lastMonthlyCoursePayTypeCookie}
        currentCard={cardInfo}
        handleChangeCard={handleChangeCard}
        restore={restore}
      />
      <CircularProgressModal isOpen={isRegistering} />
    </>
  )
}

export default PaymentSelect
